import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import { OpenBalanceOfGoodsDto } from "../dtos/OpenBalanceOfGoodsDto";
import { OpenBalanceOfGoodsModel } from "../models/OpenBalanceOfGoodsModel";
import { PurchaseOrdersService } from "src/services/documents/PurchaseOrdersService";
import { OpenBalanceOfGoodsService } from "src/services/documents/OpenBalanceOfGoodsService";
import { AppEntities } from "src/config/entities";
import { OpenBalanceOfGoodProductDto } from "../dtos/OpenBalanceOfGoodProductDto";

interface IProps {
    documentId?: string;
}

export const useFetchOpenBalancuseeOfGoods = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [documentDto, setDocumentDto] = useState<OpenBalanceOfGoodsDto | null>(null);
    const [documentModel, setDocumentModel] = useState<OpenBalanceOfGoodsModel | null>(null);
    const dataService = AppEntities.OpenBalanceOfGoods.getDataService() as OpenBalanceOfGoodsService;

    const postDocument = async () => {
        if (!documentId) return;
        await dataService.PostDocument(documentId);
        toast.success("Document posted successfully");
    }

    const cancelDocument = async () => {
        if (!documentId) return;
        await dataService.CancelDocument(documentId);
        toast.success("Document canceled successfully");
    }
    
    const updateDocument = async (documentModel: OpenBalanceOfGoodsModel) => {
        if (!documentId) return;
        console.log(documentModel)
        const requestDto: OpenBalanceOfGoodsDto = {...documentModel};
        const responseDto = await dataService.Update(requestDto);
        setDocumentDto(responseDto);
        // toast.success("Document updated successfully");
    }

    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);

            console.log("documentId", documentId);

            let responseDto: OpenBalanceOfGoodsDto | null = null;
            let responseProductDto: OpenBalanceOfGoodProductDto[] = [];
            // let responseServiceDto: IPurchaseOrderServiceDto[] = [];
            // let responsePaymentOffsetDto: IPurchaseOrderPaymentOffsetsDto[] = [];

            if (!documentId) {
                responseDto = await dataService.Create({
                    documentDate: new Date(),
                });
                setDocumentDto(responseDto);
            } else {
                responseDto = await dataService.Get(documentId);
                setDocumentDto(responseDto);
            }
            
            if (!responseDto) return;
            
            const newModel: OpenBalanceOfGoodsModel = {
                ...responseDto,
                products: [...responseProductDto]
            };
            setDocumentModel(newModel);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        fetchDocument();
    }, [documentId]);

    return {
        isDocumentLoading,
        documentDto,
        documentModel,
        postDocument,
        cancelDocument,
        updateDocument
    }
}